import axios from '@/axios'
import helper from './helper'

export default {
  autoGenerate(id) {
    return helper.post(`/api/episodes/autogenerate/${id}`, {})
  },
  getAllByMediaId(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/episodes/media/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  get(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/episodes/${id}`)
        .then(response => {
          if (response.data && response.data.length > 0) {
            return resolve(response.data[0])
          }
          return resolve(null)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  create(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/episodes`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/episodes`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  remove(item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/episodes/${item.episodeId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  removeMultiple(ids) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/episodes/remove-multiple`, {ids: ids})
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateManualQCStatus(item) {
    return helper.post('/api/episodes/update-manualqcstatus', item)
  }
}
